module.exports = __webpack_public_path__ + "img/logo.d8efaf48.png";